import { Component, computed, inject, Signal, ChangeDetectionStrategy } from '@angular/core';
import { ResourceContainerComponent } from '@softapps/core';
import { backNavigation, title } from '@softline/application';
import { translator } from '@softline/ui-core';
import { FattenerInfoComponent } from '../components/fattener-info/fattener-info.component';
import { ReportFormComponent } from '../components/report-form/report-form.component';
import { FattenerService } from '../services/fattener.service';
import { StableService } from '../services/stable.service';
import { Fattener } from '../types/fattener.model';

@Component({
  selector: 'lib-weight-report',
  templateUrl: './weight-report.component.html',
  styleUrls: ['./weight-report.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ReportFormComponent, FattenerInfoComponent, ResourceContainerComponent],
})
export class WeightReportComponent {
  protected readonly fattenerService = inject(FattenerService);
  protected readonly stableService = inject(StableService);
  private readonly t = translator();

  fattener: Signal<Fattener | undefined> = computed(() => {
    return this.fattenerService.value();
  });

  constructor() {
    backNavigation('/');
    title(this.t('#WEIGHT_REPORT.TITLE'));
  }
}
